import {
  CLIENTS_FETCH,
  CLIENTS_FETCH_ALL,
  CLIENTS_IS_FETCING,
  CLIENT_FILTER,
  CLIENT_EDIT,
  SET_CLIENT_VIEW_FILTER,
  CLEAR_CLIENTS_LIST,
  SET_CLIENT_PROFILE,
  SET_CLIENT_IB
} from 'constants/clients'

export default function clientsReducer(state = {
  list: [],
  pageable: {
      sort: {
          'clientId': 'asc',
          'name': 'asc',
          'email': false,
          'externalId': false,
          'phone': false,
      },
      size: 10,
      page: 0,
      totalPages: 0,
      totalElements: 0,
  },
  selectedProfileId: null,
  selectedIbId: null
}, action) {
  switch (action.type) {
      case CLIENTS_FETCH:
          return {
              ...state,
              list: action.payload,
          }
      case CLIENTS_FETCH_ALL:
          return {
              ...state,
              list: action.payload,
          }
      case CLIENT_EDIT:
          return {
              ...state,
              // list: state.list.find(e=>state.companyId===e.companyId)?,
          }
      case CLIENTS_IS_FETCING:
          return {
              ...state,
              isFetching: action.payload,
          }
      case CLEAR_CLIENTS_LIST:
          return {
              ...state,
              list:[]
          }
      case SET_CLIENT_PROFILE:
          return {
              ...state,
              selectedProfileId: action.payload.profileId,
              selectedProfileName: action.payload.profileName
          }
      case SET_CLIENT_IB:
          return {
              ...state,
              selectedIbId: action.payload.ibId,
              selectedIbName: action.payload.ibName
          }
      case CLIENT_FILTER:
          return {
              ...state,
              pageable: {
                  ...state.pageable,
                  ...action.payload,
                  sort: action.payload.sort ? {
                      ...Object.keys(state.pageable.sort).reduce((obj, i) => ({
                          ...obj,
                          [i]: false
                      }), {}),
                      ...action.payload.sort
                  } : state.pageable.sort,
              },
          }
      case SET_CLIENT_VIEW_FILTER:
          return {
              ...state,
              [action.payload.filterName]: action.payload.value 
          }
      default:
          return state
  }
}


// WEBPACK FOOTER //
// ./src/reducers/clients.js